import createIcon from '../../createIcon';

/**
 * @component @name HealthAndSafety
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuNSAxM0g4VjEwSDEwLjVWNy41SDEzLjVWMTBIMTZWMTNIMTMuNVYxNS41SDEwLjVWMTNaTTEyIDJMNCA1VjExLjA5QzQgMTYuMTQgNy40MSAyMC44NSAxMiAyMkMxNi41OSAyMC44NSAyMCAxNi4xNCAyMCAxMS4wOVY1TDEyIDJaTTE4IDExLjA5QzE4IDE1LjA5IDE1LjQ1IDE4Ljc5IDEyIDE5LjkyQzguNTUgMTguNzkgNiAxNS4xIDYgMTEuMDlWNi4zOUwxMiA0LjE0TDE4IDYuMzlWMTEuMDlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HealthAndSafety = createIcon('HealthAndSafety', [
  [
    'path',
    {
      d: 'M10.5 13H8V10H10.5V7.5H13.5V10H16V13H13.5V15.5H10.5V13ZM12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM18 11.09C18 15.09 15.45 18.79 12 19.92C8.55 18.79 6 15.1 6 11.09V6.39L12 4.14L18 6.39V11.09Z',
      key: '1toasp',
    },
  ],
]);

export default HealthAndSafety;
